import { translateProductName } from "./translateProductName";

export const transformProductRecomend = (item) => {
  return {
    id: item.id,
    productText: translateProductName(item.name),
    srcImage: item.image || item?.images?.[0]?.src,
    price: item.price,
    textType: "name",
  };
};
